import { FC, ReactNode } from 'react';

import { Document } from 'types';
import DocumentsTableHeader from './components/DocumentsTableHeader';
import DocumentsTableBody from './components/DocumentsTableBody';

type DocumentsTableProps = {
  title?: string;
  documents: Document[];
  handleRemoveDocument?: (document: Document) => void;
  handleReplaceDocument?: (document: Document) => void;
  renderDownloadButton?: (document: Document) => ReactNode | null;
};

const DocumentsTable: FC<DocumentsTableProps> = ({
  title = '',
  documents,
  handleRemoveDocument,
  handleReplaceDocument,
  renderDownloadButton,
}) => {
  const hasOptions = !!handleRemoveDocument || !!handleReplaceDocument;

  return (
    <div className="nk-block">
      <h6 className="nk-block-title">{title}</h6>
      <div className="card card-bordered card-preview">
        <table className="nk-tb-list nk-tb-ulist table">
          <DocumentsTableHeader hasOptions={hasOptions} />

          <DocumentsTableBody
            documents={documents}
            handleRemoveDocument={handleRemoveDocument}
            handleReplaceDocument={handleReplaceDocument}
            renderDownloadButton={renderDownloadButton}
          />
        </table>
      </div>
    </div>
  );
};

export default DocumentsTable;
